export const isKey = (value: string) => /^\w*$/.test(value);
